export default __webpack_public_path__ + "static/media/about_banner_img.9896391c.png";